<template>
    <div class="invoice-box">
        <base-header :head_id="head_id" :name="name" :account_list="account_list"></base-header>
        <base-title :title="`返回列表`" :path = "`/invoice_log`"></base-title>

        <div class="pop-content">
            <!-- 验证手机邮箱 -->
            <div class="part part1" v-if="pop_show == 1">
                <base-input :title="`注册手机号/邮箱：`" v-model="account" class="input-box" :readonly="is_read_only" :placeholder="`请输入手机号/邮箱`"></base-input>

                <div class="img-box">
                  <div id="captcha" class="captcha-content"></div>
                </div>
                <div class="send-box">
                    <base-input :title="`验证码：`" ref="inputRef" v-model="code" @input="changeCode($event)" :placeholder="`请输入验证码`" class="input-box"></base-input>
                    <base-button :name="send_btn_name" class="btn-send" @click="getCode()" :wd="`1.8rem`" :ht="`.8rem`" :fz="`.26rem`"></base-button>
                </div>
            </div>
            <!-- 选择月份 -->
            <div class="part part2" v-else-if="pop_show == 2">
                <div class="month-box">
                    <p class="title">以下为近12个月充值记录（未开票月份），请选择：</p>
                    <ul class="month-ul">
                        <li class="month-li" v-for="(item, index) in charge_list" :key="index" @click="pickMoney(item, index)">
                            <div :class="'pick ' + (compare_b(pick_month, item.create_time) ? 'picked': 'can-pick')"></div>
                            <p>
                                {{item.month}}
                                <span>（{{item.rmb}}元）</span>
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="money-box">
                    <p>
                        本次申请开票金额：
                        <span>{{total_money}}元</span>（信息服务费）
                    </p>
                </div>
            </div>
            <!-- 填写信息 -->
            <div class="part part3" v-else-if="pop_show == 3">
                <div class="form-box">
                    <base-input :title="`联系电话：`" v-model="phone" class="input-box" @blur="check_empty" :placeholder="`请填写可以联系的手机号`"></base-input>
                    <div class="toast">请选择开票类型：</div>
                    <base-radio :list="arr" :val="duty_type" @choose="choose_duty"></base-radio>
                    <base-input :title="`发票抬头：`" v-model="invoice" class="input-box" @blur="check_empty" :placeholder="duty_type == 1 || duty_type == 2 ? '请根据营业执照如实填写': '请填写姓名或个人'"></base-input>

                    <base-input v-if="duty_type == 1 || duty_type == 2" :title="`单位税号：`" v-model="company_duty" class="input-box" @blur="check_empty" :placeholder="`请填写单位税号`"></base-input>
                    <base-input v-if="duty_type == 2" :title="`开户银行：`" v-model="bank" class="input-box"></base-input>
                    <base-input v-if="duty_type == 2" :title="`银行帐户：`" v-model="bank_account" class="input-box"></base-input>
                    <base-input v-if="duty_type == 2" :title="`注册电话：`" v-model="register_phone" class="input-box"></base-input>
                    <base-input v-if="duty_type == 2" :title="`注册地址：`" v-model="register_address" class="input-box"></base-input>
                </div>
                <div class="money-box">
                    <p>
                        本次申请开票金额：
                        <span>{{total_money}}</span>元（信息服务费）
                    </p>
                </div>
            </div>
            <!-- 开票成功 -->
            <div class="part part4 info" v-else-if="pop_show == 4">
                <h2>开票提交成功</h2>
                <p>如开票资料无误，通常7工作日内开具完成，180天内可在开票记录中下载发票</p>
                <h3>12个月之前充值订单开票请联系在线客服</h3>
            </div>
            <!-- 无酒币充值记录 -->
            <div class="part part5 info" v-else-if="pop_show == 5">
                <h2>您最近12个月不含有未开票的酒币充值记录</h2>
                <p>当月充值发票请在下月自助申请</p>
                <h3>12个月之前充值订单开票请联系在线客服</h3>
            </div>
            <!-- 当月已申请 -->
            <div class="part part7 info" v-else-if="pop_show == 7">
                <h2>当月已申请开票</h2>
                <p>当月充值发票请在下月自助申请</p>
                <h3>12个月之前充值订单开票请联系在线客服</h3>
            </div>
        </div>
        <div class="pop-footer" v-if="pop_show == 1 || pop_show == 2 || pop_show == 3">
            <div class="footer-btn">
                <div class="login-err">{{err}}</div>
                <base-button :name="`下一步`" class="next-btn" @click="toNext()" v-if="pop_show<3"></base-button>
                <base-button :name="`提交`" class="next-btn" @click="savePop()" v-else-if="pop_show==3"></base-button>
            </div>
            <div class="rules" v-if="(pop_show==2||pop_show==3) && total_money>= 20000">
                <p>
                    <span>如果申请开票总金额超过2万，会自动拆分为多张且单张不超过2万</span>
                </p>
            </div>
            <div class="rules">
                <p>12个月之前充值订单开票请联系平台在线客服</p>
            </div>
        </div>
    </div>
</template>
<script>
import { baseUrls } from '@/utils/baseUrlConfig'
const base_url = baseUrls.user_url
const fp_url = baseUrls.invoice_url
export default {
    name: 'invoice',
    data() {
        return {
            head_id: this.$storage.getHeadId(),
            name: this.$storage.getUserName(),
            token: this.$storage.getAuth(),
            account_list: JSON.parse(this.$storage.getAccountList()),
            is_read_only: true,
            err: '',
            btn_lock: false,
            popData: {},
            pop_show: 0,
            send_btn_lock: false,
            account: '', //手机号
            code_check_id: '',
            code: '',
            send_btn_name: '发送验证码',
            send_timer: null,
            send_count: 60,
            img: '',
            img_check_id: '',
            my_user_info: {},
            is_charge: false, //是否充过值
            charge_list: [], //充值记录
            is_applyed: false, //是否开过票
            is_thismonth: 0, //当月是否开过票
            apply_log_list: [], //开票记录
            pick_month: '',
            total_money: 0,
            duty_type: -1, //0个人 1单位普通  2单位专用
            phone: '', //联系电话
            invoice: '', //抬头
            company_duty: '', //单位税号
            register_phone: '', //注册电话
            register_address: '', //注册地址
            bank: '', //开户银行
            bank_account: '', //银行帐户
            checkId: '',
            arr: [
                { value: 0, name: '个人' },
                { value: 1, name: '单位普通' },
                { value: 2, name: '单位专用' },
            ],
        }
    },
    mounted() {

    },
    created() {
        this.init()
    },
    watch: {
        pick_month: {
            handler(newVal) {
                let money = 0
                for (let each of this.charge_list) {
                    if (this.compare_b(newVal, each.create_time)) {
                        money += parseFloat(each.rmb)
                    }
                }
                this.total_money = money.toFixed(1)
            },
        },
    },

    methods: {
      // 初始化网易云盾
      initNECaptcha() {
        const _this = this
        let captchaIns;
        initNECaptchaWithFallback({
          captchaId: 'a757c59699f14f9cb92889cff9e566b2',
          element: '#captcha',
          mode: 'embed',
          width: '300px',
          apiVersion: 2,
          popupStyles: {
            position: 'fixed',
            top: '20%',
          },
          onVerify: function (err, data) {
            // 当验证失败时，内部会自动refresh方法，无需手动再调用一次
            if (err) return
            // 若成功拿到 validate，可向后端发送请求
            _this.getNewCode(data.validate)
          }
        }, function onload(instance) {
          captchaIns = instance
        }, function onerror(err) {
          console.warn(err)
        })
      },
      // 网易云盾code验证
      getNewCode(code) {
        $.ajax({
          url: base_url + `/NewCode`,
          type: 'POST',
          data: { NECaptchaValidate: code },
          async: false,
          success: (res) => {
            if (res.code == 0) {
              this.checkId = res.check_id
            } else {
              this.err = res.error? res.error : '验证码有误请重新输入！'
            }
          }
        })
      },
        changeCode(val) {
            this.$nextTick(() => {
                if (val.length > 6) {
                    this.code = val.slice(0, 6)
                }
            })
        },
        // 下一步
        toNext() {
            this.err = ''
            if (this.pop_show == 1) {
                if (!this.checkAccount()) {
                    return false
                }
              if (!this.checkId) {
                this.err = '请完成安全验证'
                return false
              }
                this.checkCode().then((res) => {
                    if (res) {
                        this.pop_show++
                    } else {
                        return false
                    }
                })
            } else if (this.pop_show == 2) {
                if (this.total_money == 0) {
                    this.err = '请选择申请开票的月份金额！'
                    return false
                }
                this.pop_show++
                this.$nextTick(() => {
                    this.search_apply_log(3)
                })
            }
        },
        // 查询开票申请记录 type //1：当月  2：全部  3：上次成功
        async search_apply_log(type) {
            let _this = this
            await this.$http.q_hd('GetMonthLog', fp_url, { token: this.token, type: type }).then((res) => {
                if (res.code == 0 && res.msg && res.msg.length > 0) {
                    if (type == 1) {
                        this.is_thismonth = res.thismonth
                    } else if (type == 2) {
                        this.is_applyed = true
                        this.apply_log_list = res.msg
                        this.pop_show = 7
                    } else if (type == 3) {
                        this.setDats(res.msg[0])
                    }
                } else {
                    if (type == 1) {
                        this.is_thismonth = res.thismonth
                    } else if (type == 2) {
                        this.is_applyed = false
                        this.apply_log_list = []
                        this.pop_show = 6
                    }
                }

                if (type == 1 && this.is_thismonth) {
                    this.pop_show = 7
                }
            })
        },

        //用户基本信息查询
        async init() {
            await this.search_apply_log(1)

            if (this.pop_show == 7) {
                return false
            }
            await this.$http.getUserInfo(this.token).then((res) => {
                if (res.result == 0 && res.temp) {
                    this.my_user_info = res.temp
                    this.account = this.my_user_info.moile
                        ? this.my_user_info.moile
                        : this.my_user_info.email
                        ? this.my_user_info.email
                        : ''
                }
            })

            await this.$http.q_hd('GetBillLog', fp_url, { token: this.token, type: 1 }).then((res) => {
                if (res.code == 0 && res.msg && res.msg.length > 0) {
                    this.is_charge = true
                    let list = res.msg
                    list = list.map((rr) => {
                        rr.month = rr.create_time.split('-')[0] + '年' + rr.create_time.split('-')[1] + '月'
                        return rr
                    })
                    this.charge_list = list
                } else {
                    this.is_charge = false
                    this.charge_list = []
                }
            })

            if (this.is_charge) {
                // 12个月内有充值过
                this.pop_show = this.account ? 1 : 2
                this.$nextTick(() => {
                    if (this.pop_show == 1) {
                        // this.getCaptchImg()
                        this.initNECaptcha()
                    }
                })
            } else {
                this.pop_show = 5
            }
        },
        choose_duty(val) {
            this.err = ''
            this.duty_type = val
        },
        // 选择开票月份
        pickMoney(item, index) {
            this.err = ''
            if (this.pick_month == item.create_time) {
                this.pick_month = ''
            } else {
                this.pick_month = item.create_time
            }
        },
        compare_b(date1, date2) {
            if (Date.parse(new Date(date1.replace(/-/g, '/'))) >= Date.parse(new Date(date2.replace(/-/g, '/')))) {
                return true
            } else {
                return false
            }
        },

        savePop() {
            if (this.btn_lock) {
                return false
            }
            var datas = {}
            datas.token = this.token
            datas.user_name = this.my_user_info ? this.my_user_info.name : ''
            datas.phone = this.phone.trim()
            datas.money = this.total_money
            datas.duty_type = this.duty_type
            datas.invoice = this.invoice.trim()
            datas.company_duty = this.company_duty.trim()
            datas.register_address = this.register_address.trim()
            datas.register_phone = this.register_phone.trim()
            datas.bank = this.bank.trim()
            datas.bank_account = this.bank_account.trim()
            datas.month = this.pick_month
            datas.key = this.code_check_id
            this.popData = datas

            if (datas.phone == '') {
                this.err = '请输入可以联系的手机号'
                return false
            }
            if (!this.checkPhone(this.phone)) {
                this.err = '手机号码格式不正确！'
                return false
            }
            if (datas.duty_type == -1) {
                this.err = '请选择开票类型'
                return false
            }
            if (this.total_money == 0 || this.pick_month == '') {
                this.err = '开票金额不能为空'
                return false
            }
            if (datas.duty_type == 0) {
                if (datas.invoice == '') {
                    this.err = '请输入发票抬头'
                    return false
                }
            } else if (datas.duty_type == 2) {
                if (datas.invoice == '') {
                    this.err = '请输入发票抬头'
                    return false
                }
                if (datas.company_duty == '') {
                    this.err = '请输入单位税号'
                    return false
                }
                if (datas.bank == '') {
                    this.err = '请输入开户银行'
                    return false
                }
                if (datas.bank_account == '') {
                    this.err = '请输入银行帐户'
                    return false
                }
                if (datas.register_phone == '') {
                    this.err = '请输入注册电话'
                    return false
                }
                if (datas.register_address == '') {
                    this.err = '请输入注册地址'
                    return false
                }
            } else {
                if (datas.invoice == '') {
                    this.err = '请输入发票抬头'
                    return false
                }
                if (datas.company_duty == '') {
                    this.err = '请输入单位税号'
                    return false
                }
            }
            this.save(datas)
        },

        save(datas) {
            this.btn_lock = true
            this.$http.q_hd('ApplyUserDuty', fp_url, datas).then((res) => {
                if (res.code == 0) {
                    this.btn_lock = false
                    this.err = ''
                    this.pop_show = 4
                    this.is_thismonth = 1
                } else {
                    this.btn_lock = false
                    this.err = res.error ? res.error : res.err ? res.err : '提交失败，请联系管理员'
                }
            })
        },

        setDats(data) {
            this.phone = data.phone
            this.duty_type = data.type
            this.invoice = data.invoice
            this.company_duty = data.company_duty
            this.register_address = data.register_address
            this.register_phone = data.register_phone
            this.bank = data.bank
            this.bank_account = data.bank_account
        },

        checkRealName() {
            this.realname = this.realname.trim()
            var flag = false
            if (!/^[\u4e00-\u9fa5]{1,7}(·[\u4e00-\u9fa5]{1,7}){0,2}$/.test(this.realname)) {
                this.err = '请填写正确的姓名！'
            } else {
                this.err = ''
                flag = true
            }
            return flag
        },

        getCaptchImg() {
            this.$http.getCaptchImg().then((res) => {
                if (res) {
                    $('.captchaImg').attr('src', 'data:image/png;base64,' + res.img.fileContents)
                    this.img_check_id = res.check_id
                }
            })
        },

        // 获取短信验证码
        getCode() {
            this.err = ''
            if (!this.checkId) {
              this.err = '请完成安全验证'
              return false
            }

            if (this.send_btn_lock) {
                this.err = '验证码已发送，请稍等！'
                return false
            }
            if (!this.checkAccount()) {
                return false
            }


            if (this.account.indexOf('@') > -1) {
                this.send_btn_lock = true

                this.$http.sedEmail(this.account).then((res) => {
                    if (res.code == 0) {
                        this.code_check_id = res.check_id
                        this.$nextTick(() => {
                            this.$refs.inputRef.focusInput()
                        })
                        this.send_btn_name = '请稍等(' + this.send_count + ')'
                        this.send_timer = setInterval(() => {
                            this.send_count--
                            if (this.send_count == 0) {
                                this.send_btn_lock = false
                                this.send_btn_name = '重新发送'
                                this.send_count = 60
                                clearInterval(this.send_timer)
                                // this.getCaptchImg()
                            } else {
                                this.send_btn_name = '请稍等(' + this.send_count + ')'
                            }
                        }, 1000)
                    } else {
                        this.err = res.error ? res.error : '发送失败'
                        this.send_btn_lock = false
                        // this.getCaptchImg()
                    }
                })
            } else {
                this.send_btn_lock = true

                this.$http.sendCode(this.account, this.checkId ,this.token).then((res) => {
                    if (res.code == 0) {
                        this.code_check_id = res.check_id
                        this.$nextTick(() => {
                            this.$refs.inputRef.focusInput()
                        })
                        this.send_btn_name = '请稍等(' + this.send_count + ')'
                        this.send_timer = setInterval(() => {
                            this.send_count--
                            if (this.send_count == 0) {
                                this.send_btn_lock = false
                                this.send_btn_name = '重新发送'
                                this.send_count = 60
                                clearInterval(this.send_timer)
                            } else {
                                this.send_btn_name = '请稍等(' + this.send_count + ')'
                            }
                        }, 1000)
                    } else {
                        this.err = res.error ? res.error : '发送失败'
                        this.send_btn_lock = false
                    }
                })
            }
        },
        // 校验图形码
        checkImg() {
            this.err = ''
            this.img = this.img.trim()
            if (this.img == '') {
                this.err = '请输入图形验证码运算结果'
                return false
            } else {
                var flag = false
                $.ajax({
                    url: base_url + '/VerificationCode?code=' + this.img + '&check_id=' + this.img_check_id,
                    async: false,
                    success: (res) => {
                        if (res.code == 0) {
                            flag = true
                            this.err = ''
                        } else {
                            this.err = res.error ? res.error : '图形验证失败或已过期，请刷新重试！'
                        }
                    },
                })
                return flag
            }
        },
        // 校验手机验证码
        async checkCode() {
            this.err = ''
            this.account = this.account.trim()
            this.code = this.code.trim()
            if (this.code == '') {
                this.err = '请填写验证码！'
                return false
            }
            let flag = false
            if (this.account.indexOf('@') > -1) {
                await this.$http.verificationEmail(this.account, this.code, this.code_check_id).then((res) => {
                    if (res.code == 0) {
                        this.code_check_id = res.key
                        flag = true
                    } else {
                        this.err = res.error ? res.error : '验证码有误请重新输入！'
                    }
                })
            } else {
                await this.$http.verificationNote(this.account, this.code, this.code_check_id).then((res) => {
                    if (res.code == 0) {
                        this.code_check_id = res.key
                        flag = true
                    } else {
                        this.err = res.error ? res.error : '验证码有误请重新输入！'
                    }
                })
            }
            return flag
        },

        // 校验注册手机号/邮箱
        checkAccount() {
            this.err = ''
            this.account = this.account.trim()
            if (this.account == '') {
                this.err = '请填写手机号或邮箱！'
                return false
            }
            if (this.account.indexOf('@') > -1) {
                if (!this.checkEmail(this.account)) {
                    return false
                }
            } else {
                if (!this.checkPhone(this.account)) {
                    return false
                }
            }
            return true
        },
        // 校验手机号格式
        checkPhone(val) {
            this.err = ''
            val = val.trim()
            if (val == '') {
                this.err = '请填写手机号！'
                return false
            }
            if (val.length != 11 || !/^1[3456789][0-9]{9}$/.test(val)) {
                this.err = '请填写正确的手机号！'
                return false
            }
            return true
        },

        // 邮箱验证
        checkEmail(val) {
            this.err = ''
            if (/^[1-9][0-9]{4,}@qq.com$/.test(val)) {
                return true
            } else {
                this.err = '邮箱号格式不正确！'
                return false
            }
        },
        // 检测空
        check_empty(val) {
            this.err = ''
            let text = val.trim()
            if (text == '') {
                this.err = '信息不能为空'
                return false
            }
            return true
        },
    },
}
</script>
<style lang="scss" scoped>
.invoice-box {
    padding-bottom: 0.5rem;
    .input-box {
        margin-top: 0.32rem;
    }
    .login-btn {
        margin-top: 0.2rem;
    }
    .tips-new {
        width: 100%;
        height: 0.36rem;
        line-height: 0.36rem;
        text-align: center;
        margin: 0 auto;
        color: #ff0000;
        font-size: 0.22rem;
    }
    .login-err {
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        padding-left: 2.54rem;
        text-align: left;
        margin: 0 auto;
        color: #ff0000;
        font-size: 0.22rem;
    }
    h2 {
        font-size: 0.26rem;
        color: #2f92eb;
        text-align: center;
        text-decoration: underline;
        padding-top: 0.4rem;
        &:hover {
            cursor: pointer;
            color: #00427e;
        }
    }
    .send-box {
        position: relative;
        width: 6.22rem;
        margin: 0 auto;
        .btn-send {
            position: absolute;
            top: 50%;
            right: 0.11rem;
            transform: translateY(-50%);
        }
    }
    .img-box {
        position: relative;
        width: 6.22rem;
        margin: 0 auto;

        .captchaImg {
            position: absolute;
            top: 50%;
            right: 0.2rem;
            width: 1.8rem;
            height: 0.72rem;
            transform: translateY(-50%);
        }
    }
    .toast {
        width: 6.22rem;
        margin: 0 auto;
        font-size: 0.28rem;
        color: #c39b5e;
        height: 0.34rem;
        line-height: 0.34rem;
        padding: 0.2rem 0 0.5rem 0;
        text-align: left;
    }
    .money-box {
        margin-top: 0.6rem;
        p {
            text-align: center;
            font-size: 0.28rem;
            color: #2e2e2e;
            height: 0.55rem;
            line-height: 0.55rem;
            span {
                color: #c39b5e;
                font-size: 0.5rem;
                font-weight: bold;
                padding-right: 0.1rem;
            }
        }
    }
    .info {
        width: 100%;
        margin-top: 1rem;

        p {
            margin: 0 auto;
            width: 5rem;
            font-size: 0.22rem;
            color: #ff0000;
            text-align: center;
            height: 0.36rem;
            line-height: 0.36rem;
        }
        h2 {
            display: block;
            color: #212121;
            font-size: 0.36rem;
            font-weight: bold;
            width: 100%;
            text-align: center;
            height: 1rem;
            line-height: 1rem;
            text-decoration: none;
            margin-bottom: 0.25rem;
        }
        h3 {
            margin: 0 auto;
            width: 100%;
            font-size: 0.22rem;
            color: #919191;
            text-align: center;
            height: 0.9rem;
            line-height: 0.9rem;
            position: fixed;
            bottom: 0;
            left: 0;
        }
    }
    .month-box {
        width: 6.9rem;
        margin: 0 auto;
        height: auto;
        background: #ffffff;
        border-radius: 0.2rem;
        p {
            font-size: 0.26rem;
            color: #212121;
            height: 0.25rem;
            line-height: 0.25rem;
            span {
                font-size: 0.3rem;
                color: #c39b5e;
                height: 0.25rem;
                line-height: 0.25rem;
            }
        }
        .title {
            width: 100%;
            padding: 0.25rem 0 0.5rem 0.22rem;
        }
        .month-ul {
            width: 6.44rem;
            height: auto;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            align-content: center;
            flex-wrap: wrap;
            margin-left: 0.22rem;

            .month-li {
                list-style: none;
                width: 6.44rem;
                height: 1rem;
                line-height: 1rem;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                border-top: 0.01rem solid #dddddd;
                p {
                    font-size: 0.3rem;
                }
                .pick {
                    margin-left: 0.1rem;
                    margin-right: 0.3rem;
                    width: 0.4rem;
                    height: 0.4rem;
                    background: url(~@/assets/img/pick.png) 0 0 no-repeat;
                    background-size: 100% auto;
                    // &.can-pick:hover {
                    //     cursor: pointer;
                    //     background-position-y: 0;
                    // }
                    &.picked {
                        cursor: default;
                        background-position-y: -0.4rem;
                    }
                }
            }
        }
    }
    .rules {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        height: 0.34rem;
        line-height: 0.34rem;
        margin-top: 0.3rem;
        p {
            font-size: 0.24rem;
            color: #919191;
            height: 0.34rem;
            line-height: 0.34rem;
            padding-bottom: 0.5rem;
            span {
                display: block;
                color: #ff0000;
            }
        }
    }
}
</style>

<style>
.captcha-content .yidun_intellisense--light .yidun_intelli-control {
  background: linear-gradient(0deg, #c4a160, #6f542b);
  border-radius: 1rem;
}
.captcha-content .yidun_intellisense--light .yidun_intelli-tips {
  color: #ffffff;
}
</style>




// WEBPACK FOOTER //
// src/view/invoice/index.vue